import { ReactNode } from "react"
import { motion } from 'framer-motion'

interface WelcomeLayoutProps {
  children: ReactNode
  currentStep: number
  title: string
  subtitle?: string
  isCompleting?: boolean
}

export function WelcomeLayout({ children, currentStep, title, subtitle, isCompleting }: WelcomeLayoutProps) {

  return (
    <motion.div 
      className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8"
      animate={isCompleting ? { opacity: 0, scale: 0.95 } : { opacity: 1, scale: 1 }}
      transition={{ duration: 1, ease: "easeInOut", delay: isCompleting ? 1 : 0 }}
    >
      <div className="max-w-4xl mx-auto">
        {!isCompleting && (
          <motion.div
            className="text-center mb-8"
            key={`${title}-${subtitle}`}
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
          >
            <h1 className="text-3xl font-bold text-gray-900 mb-2">{title}</h1>
            {subtitle && <p className="text-lg text-gray-700">{subtitle}</p>}
          </motion.div>
        )}

        {!isCompleting && (
          <motion.div
            className="flex justify-center items-center space-x-2 mb-8"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.3, delay: 0.2 }}
          >
            {Array.from({ length: 5 }, (_, index) => (
              <motion.div
                key={index}
                className={`w-2 h-2 rounded-full transition-colors duration-200 ${
                  index < currentStep ? 'bg-[#290BD9]' : 'bg-white border border-gray-300'
                }`}
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ duration: 0.2, delay: index * 0.05 }}
              />
            ))}
          </motion.div>
        )}
        
        {children}

        {/* Debug onboarding variables */}
        {/* <div className="mt-4 p-4 bg-gray-100 rounded border text-xs">
          <div className="font-bold mb-2">Debug - Onboarding Variables:</div>
          <div>businessType: {onboardingData.businessType || 'null'}</div>
          <div>advertisingAudience: {onboardingData.advertisingAudience || 'null'}</div>
          <div>experienceLevel: {onboardingData.experienceLevel || 'null'}</div>
          <div>currentAdvertisingSpend: {onboardingData.currentAdvertisingSpend || 'null'}</div>
          <div>completeData: {onboardingData.completeData ? 'exists' : 'null'}</div>
        </div> */}
      </div>
    </motion.div>
  )
}